import cn from 'classnames/bind';
import React, { FC, useId } from 'react';

import CheckIcon from '../CheckIcon/CheckIcon';

import { OptionLabelProps } from './OptionLabel.types';
import styles from './OptionLabel.module.css';

const cx = cn.bind(styles);

export const OptionLabel: FC<OptionLabelProps> = ({
    isChecked,
    disabled,
    isInlineNote,
    value,
    name,
    note,
    icon,
    group,
    handleSelect,
}) => {
    const inputId = useId();

    return (
        <div
            className={cx('item', {
                item_checked: isChecked,
                item_disabled: disabled,
            })}
        >
            <input
                id={inputId}
                className={cx('input')}
                type="radio"
                disabled={disabled}
                value={value as Readonly<typeof value>}
                checked={isChecked}
                name={group}
                onChange={handleSelect}
            />
            <div className={cx('item-inner')}>
                <div className={cx('icon', { icon_static: icon })}>{icon || <CheckIcon />}</div>
                <label className={cx('label')} htmlFor={inputId}>
                    {name}
                </label>
                {note && (
                    <div
                        className={cx('note', {
                            note_inline: isInlineNote,
                        })}
                    >
                        {note}
                    </div>
                )}
            </div>
        </div>
    );
};
